<template>
  <customershift-check
    :data.sync="checkDataInfo"
    :sna-id="snaId"
  >
    <template>
      <check-module :title="`客户列表`" :is-table="true">
        <div style="position: relative">
          <div class="system_btn">
            <el-button type="primary" @click="batchPassCheck"
            >批量通过</el-button
            >
            <el-button @click="batchRejectCheck">批量不通过</el-button>
          </div>
          <el-table
            ref="multipleTable"
            :data="tableData"
            border
            height="300px"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="tableHeader"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="客户编号">
              <template slot-scope="scope">{{scope.row.cusCode}}</template>
            </el-table-column>
            <el-table-column prop="seriesName" label="客户名称">
              <template slot-scope="scope"><el-link type="primary" @click="getCustomerDetail(scope.row)" :underline="false">{{scope.row.cusName}}</el-link></template>
            </el-table-column>
            <el-table-column
              prop="starLevel"
              label="星级"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="useCredit"
              label="可用信用"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>{{ scope.row.useCredit }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="contractTotal"
              label="贸易总额"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="count" label="签订合同" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="badDebt"
              label="坏账"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>{{ scope.row.badDebt | toFixed }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="bizAddress"
              label="公司地址"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="ccContacts"
              label="联系人"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="ccPhone"
              label="电话"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="cusImplevel"
              label="重要等级"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="staffCnName"
              label="当前负责人"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="clientName"
              label="委托人"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="createDate"
              label="添加时间"
              show-overflow-tooltip
            >
              <template v-slot="{ row }">{{row.createDate | formatData}}</template>
            </el-table-column>
            <el-table-column
              prop="endDate"
              label="最后成单时间"
              show-overflow-tooltip
            >
              <template v-slot="{ row }">{{row.createDate | formatData}}</template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="审批结果"
              width="160"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-radio v-model="scope.row.transferState" label="1" class="theme-blue">通过</el-radio>
                <el-radio v-model="scope.row.transferState" label="2" class="theme-blue">不通过</el-radio
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </check-module>
      <check-module
        :title="`申请信息`"
      >
        <el-row>
          <el-col :span="8">
            <div class="pb20">申请人：{{checkDataInfo.createUser}}</div>
          </el-col>
          <el-col :span="8">
            <div class="pb20">申请时间：{{checkDataInfo.createDate | formatData}}</div>
          </el-col>
          <el-col :span="8">
            <div class="pb20">所属部门：{{checkDataInfo.orgName}}</div>
          </el-col>
        </el-row>
        <el-row>
          <slot name="beforeRemark"></slot>
          <el-col :span="16">
            <div class="">转移至：{{checkDataInfo.transferOrgName}}</div>
          </el-col>
        </el-row>
      </check-module>
    </template>
    <template v-slot:footer>
      <el-button type="primary" @click="submitCheck">提交</el-button>
    </template>
  </customershift-check>
</template>

<script>
import customershiftCheck from '@/views/workbench/workCheckManage/customershiftCheck/customershiftCheck'
import checkMixin from '@/mixin/checkMixin'
import { deepClone } from '@/util'
import checkApi from '@/api/workbench/check'
export default {
  name: 'customershiftCheckView',
  mixins: [checkMixin],
  components: {
    customershiftCheck
  },
  data () {
    return {
      checkDetailName: 'customershiftcheckdetail',
      tableData: [],
      checkSelected: []
    }
  },
  created () {
    this.getCustomershiftCheckInfo()
  },
  methods: {
    submitCheck (form) {
      const { checkDataInfo } = this
      const result = checkDataInfo.customerStateVoList.find(item => item.transferState !== '1' && item.transferState !== '2')
      const params = this.formatCheckParams(form)
      if (result) {
        this.$message.error('请处理所有数据！')
        return
      }
      params.customerTransferApprovalVo = {
        customerStateVoList: checkDataInfo.customerStateVoList.map(itemex => {
          return Object.assign(itemex, {
            transferState: Number(itemex.transferState)
          })
        })
      }
      params.auditType = true
      checkApi.submitCustomershiftCheck(params).then(res => {
        this.goCheckDetail(res)
      })
    },
    getCustomershiftCheckInfo () {
      const {
        snaId
      } = this
      checkApi.getCustomershiftCheckInfo({
        snaId
      }).then(res => {
        if (this.isSuccess(res)) {
          this.checkDataInfo = res.data.obj
          this.tableData = res.data.obj.customerStateVoList || []
        }
      })
    },
    handleSelectionChange (val) {
      this.checkSelected = val
    },
    // 批量通过
    batchPassCheck () {
      if (this.checkSelected.length === 0) {
        this.$message({
          message: '请先选择数据',
          type: 'error'
        })
        return
      }
      this.checkSelected.forEach(item => {
        item.transferState = '1'
      })
    },
    getCustomerDetail (row) {
      this.$router.push({ name: 'customer/details', query: { id: row.id } })
    },
    // 批量不通过
    batchRejectCheck () {
      if (this.checkSelected.length === 0) {
        this.$message({
          message: '请先选择数据',
          type: 'error'
        })
        return
      }
      this.checkSelected.forEach(item => {
        item.transferState = '2'
      })
    }
  }
}
</script>

<style scoped>
.system_btn{
  position: absolute;
  right: 0;
  top:-40px;
}
  /deep/.el-radio{
    margin-right: 10px;
  }
  /deep/.el-radio__label{
    padding-left: 5px;
  }
</style>
